import { MessageType, RawCallMessage, RawMessage } from "@/store/chats/types";

export const getIsRawMessageCallType = (
  message: RawMessage,
): message is RawCallMessage => message.messageType === MessageType.Call;
